const KEY = "islasol_recent";
const MAX = 8;

export const getRecent = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
export const addRecent = (id) => {
  const list = [id, ...getRecent().filter((x) => x !== id)].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(list));
};
export const removeRecent = (id) => {
  const list = getRecent().filter((x) => x !== id);
  localStorage.setItem(KEY, JSON.stringify(list));
  return list;
};
export const clearRecent = () => { localStorage.removeItem(KEY); return []; };
